import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.css';

// Add type declaration for deferredPrompt
declare global {
  interface Window {
    deferredPrompt: any;
  }
}

// Viewport height fix for mobile browsers
const setViewportHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

// Set initial viewport height
setViewportHeight();

// Update viewport height on resize and orientation change
window.addEventListener('resize', setViewportHeight);
window.addEventListener('orientationchange', setViewportHeight);

// Add Font Awesome CDN link
const fontAwesome = document.createElement('link');
fontAwesome.rel = 'stylesheet';
fontAwesome.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css';
document.head.appendChild(fontAwesome);

// Add Plus Jakarta Sans font
const plusJakartaVariable = document.createElement('link');
plusJakartaVariable.rel = 'stylesheet';
plusJakartaVariable.href = 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300..800&display=swap';
document.head.appendChild(plusJakartaVariable);

// Add meta theme-color for Android
const metaThemeColor = document.createElement('meta');
metaThemeColor.name = 'theme-color';
metaThemeColor.content = '#4F46E5'; // Using the theme color from manifest
document.head.appendChild(metaThemeColor);

// Add manifest link
const manifestLink = document.createElement('link');
manifestLink.rel = 'manifest';
manifestLink.href = '/manifest.json';
document.head.appendChild(manifestLink);

// Register service worker
if ('serviceWorker' in navigator) {
  console.log('🔍 Service Worker: Browser supports service workers');
  window.addEventListener('load', async () => {
    try {
      // Check if there's an existing registration
      const existingReg = await navigator.serviceWorker.getRegistration();
      if (existingReg) {
        console.log('ℹ️ Service Worker: Found existing registration', existingReg);
      }

      const registration = await navigator.serviceWorker.register('/service-worker.js', {
        scope: '/'
      });
      
      console.log('✅ Service Worker: Registered successfully', registration);
      
      // Check if PWA is installable
      window.addEventListener('beforeinstallprompt', (e) => {
        console.log('🔔 PWA install prompt is ready');
        // Optionally, store the event for later use
        e.preventDefault();
        window.deferredPrompt = e;
      });

      // Listen for successful installation
      window.addEventListener('appinstalled', () => {
        console.log('🎉 PWA was installed');
        window.deferredPrompt = null;
      });

    } catch (error) {
      console.error('❌ Service Worker: Registration failed:', error);
    }
  });
} else {
  console.warn('⚠️ Service Worker: Browser does not support service workers');
}

// Render the app
ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
);
